import { useState, useEffect } from 'react';

// Highlights the section whose card currently sits in the upper band of the
// viewport. jsdom has no IntersectionObserver — the hook no-ops there.
const useScrollSpy = (ids) => {
    const [activeId, setActiveId] = useState(ids[0] || null);
    useEffect(() => {
        if (typeof IntersectionObserver === 'undefined') return undefined;
        const observer = new IntersectionObserver((entries) => {
            const visible = entries
                .filter(e => e.isIntersecting)
                .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
            if (visible.length > 0) setActiveId(visible[0].target.id);
        }, { rootMargin: '-10% 0px -70% 0px' });
        ids.forEach(id => {
            const el = document.getElementById(id);
            if (el) observer.observe(el);
        });
        return () => observer.disconnect();
    }, [ids]);
    return activeId;
};

export default useScrollSpy;
